(() => {
  const sectionId = "cart-icon-bubble";

  const getSectionInnerHTML = (html, selector = ".shopify-section") => {
    const parsedSection = new DOMParser().parseFromString(html, "text/html");
    return parsedSection.querySelector(selector)?.innerHTML;
  };

  const getVisibleIconPaths = (element) =>
    [...element.querySelectorAll("svg path[fill]")].filter(
      (path) => !path.closest("mask"),
    );

  const renderCartIconBubble = (sectionHtml) => {
    const container = document.getElementById(sectionId);
    if (!container || !sectionHtml) return;

    const currentIconFill =
      getVisibleIconPaths(container)[0]?.getAttribute("fill");
    const innerHTML = getSectionInnerHTML(sectionHtml);
    if (innerHTML !== undefined) {
      container.innerHTML = innerHTML;
      if (currentIconFill) {
        getVisibleIconPaths(container).forEach((path) =>
          path.setAttribute("fill", currentIconFill),
        );
      }
    }
  };

  const refreshCartIconBubble = () =>
    fetch(`${window.Shopify.routes.root}?sections=${sectionId}`)
      .then((response) => response.json())
      .then((sections) => {
        renderCartIconBubble(sections[sectionId]);
      })
      .catch((error) => {
        console.error("Error refreshing cart icon bubble:", error);
      });

  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined"
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const sectionHtml = event.cartData?.sections?.[sectionId];

      if (sectionHtml) {
        renderCartIconBubble(sectionHtml);
        return;
      }

      refreshCartIconBubble();
    });
  }
})();
